import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCapeNotifications } from './redux/selectors/CapeNotificationSelector';
import { errorNotification, removeNotification } from './redux/actions/CapeNotificationActions';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const capeNotificationContainer = (WrappedComponent) => {
  class CapeNotificationContainer extends Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
      const { notifications } = nextProps;
      if (notifications && notifications.length > 0) {
        this.props.errorNotification(notifications.reduce((message, error) => `${message}\n${error}`));
        this.props.removeNotification();
      }
    }

    render() {
      return (<WrappedComponent {...this.props} />);
    }
  }

  const mapStateToProps = state => ({
    notifications: getCapeNotifications(state),
  });

  const mapDispatchToProps = dispatch => bindActionCreators({
    errorNotification,
    removeNotification,
  }, dispatch);

  CapeNotificationContainer.displayName = `CapeNotificationContainer(${getDisplayName(WrappedComponent)})`;
  CapeNotificationContainer.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.string),
    errorNotification: PropTypes.func,
    removeNotification: PropTypes.func,
  };

  return connect(mapStateToProps, mapDispatchToProps)(CapeNotificationContainer);
};


export { capeNotificationContainer as default };
